<h2>Plan N’Go - Modification concession</h2>
<div class="wrapper" style="width: 1100px !important;">
  <form>
    <div class="form-group mt-3" style="width: 600px">
      <div >Marques autorisées :</div>
      <div class="d-flex">
        <div *ngFor="let brand of softnetConfiguration.Config.General.Brands; let index = index" class="font-weight-normal mr-2">{{brand.Brand}}</div>
      </div>
    </div>

    <div class="form-group mt-3" style="width: 600px">
      <div >Mobilités :</div>
      <div>
        <div *ngFor="let mobility of softnetConfiguration.Config.Rent.RentCategoriesMap; let index = index" class="font-weight-normal">- {{mobility.RentCatName}}</div>
      </div>
    </div>

    <div class="form-group mt-3" style="width: 600px">
      <div >Alternatives de mobilité :</div>
      <div>
        <div *ngFor="let mobilityAlternative of softnetConfiguration.Config.Rent.MobilityAlternativesMap" class="font-weight-normal">- {{mobilityAlternative.MobilityAlternativeName}}</div>
      </div>
    </div>

    <div class="form-group mt-3" style="width: 600px">
      <div >Jours autorisés :</div>
      <div class="d-inline-flex">
        <div *ngFor="let day of softnetConfiguration.Config.AppBehavior.OnlyOnWeekdays.split(''); let index = index" class="font-weight-normal mr-1">{{getDayOfTheWeek(day)}}</div>
      </div>
    </div>
    <div class="mt-3 form-group d-flex flex-column">
      <span>Heures autorisées :</span>

      <div class="d-inline-flex">
        <span class="mr-2">Réception :</span>
        <div class="font-weight-normal mr-2">{{softnetConfiguration.Config.AppBehavior.StartEarliestTime}}</div>
        <div class="font-weight-normal">{{softnetConfiguration.Config.AppBehavior.StartLatestTime}}</div>
      </div>

      <div class="d-inline-flex">
        <span class="mr-2">Travaux :</span>
        <div class="font-weight-normal mr-2">{{softnetConfiguration.Config.AppBehavior.EndEarliestTime}}</div>
        <div class="font-weight-normal">{{softnetConfiguration.Config.AppBehavior.EndLatestTime}}</div>
      </div>
    </div>

    <div class="form-group mt-3" style="width: 600px">
      <div>Délai minimum :</div>
      <div class="font-weight-normal">{{softnetConfiguration.Config.AppBehavior.FirstAppDays}}</div>
    </div>

    <div class="form-group mt-3" style="width: 600px">
      <div>Conseillers services autorisés :</div>
      <div *ngFor="let sa of softnetConfiguration.Config.AppBehavior.SA" class="font-weight-normal">
        <div class="d-inline-flex">
          {{sa.SAName}} (<span *ngFor="let brand of sa.Brands; let last = last" [ngClass]="{'mr-1': !last}">{{brand}}<ng-container *ngIf="!last">,</ng-container></span>)
        </div>
      </div>
    </div>

    <div class="font-weight-bold">Opérations :</div>
    <div class="operations-box">
      <div *ngFor="let operation of softnetConfiguration.Config.Operations.OperationMap" class="d-inline-flex">
        <div class="form-group mt-3 flex-column mr-1" style="width: 200px">
          <div >Alias soft-net :</div>
          <div class="font-weight-normal">{{operation.OperationName}}</div>
        </div>
        <div class="form-group mt-3 flex-column mr-1" style="width: 200px">
          <div >Description :</div>
          <div class="font-weight-normal">{{operation.OperationDescription}}</div>
        </div>
        <div class="form-group mt-3 flex-column mr-1" style="width: 200px">
          <div >Max par jour :</div>
          <div class="font-weight-normal">{{operation.MaxPerDay}}</div>
        </div>
        <div class="form-group mt-3 flex-column mr-1" style="width: 200px">
          <div >Max par semaine :</div>
          <div class="font-weight-normal">{{operation.MaxPerWeek}}</div>
        </div>
        <div class="form-group mt-3 flex-column" style="width: 200px">
          <div >Jours autorisés :</div>
          <div class="d-inline-flex">
            <div *ngFor="let day of operation.OnlyOnWeekdays.split('')" class="font-weight-normal mr-1">{{getDayAbvOfTheWeek(day)}}</div>
          </div>
        </div>
      </div>
    </div>


    <div class="btn-group mt-3 mb-5">
      <div>
        <button (click)="onCancelClick()" class="btn btn-light btn100px border-dark p-2">Retour</button>
      </div>
    </div>
  </form>
</div>
